module.exports = __webpack_public_path__ + "assets/video/ingela.641c90f.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ingela.webm
// module id = 1071
// module chunks = 0